<template>
  <div :class="{ help: true, 'is-small': size === 'small' }">
    <button
      :title="$t('고객지원')"
      type="button"
      class="help-button officehome-gnb-cs"
      :class="{ new: !helpNoticeFlag, 'icon-button__selected': isQnaVisible }"
      @click="showQnaList"
    >
      <QuestionIcon v-if="size === 'small'" />
    </button>
    <div v-show="isQnaVisible" ref="helpDetail" class="alarm-detail" tabindex="0" @focusout="closeDropdownMenu">
      <div class="alarm-list">
        <a :href="serviceGuideUrl" target="_blank" class="alarm-list-item officehome-gnb-cs">
          {{ $t('이용 가이드') }}
        </a>
        <a href="https://www.hiworks.com/faq" target="_blank" class="alarm-list-item officehome-gnb-cs">
          {{ $t('자주 하는 질문') }}
        </a>
        <a
          href="https://www.hiworks.com/cs/notice"
          target="_blank"
          class="alarm-list-item officehome-gnb-cs"
          @click="helpNoticeFlagReset"
        >
          {{ $t('공지사항') }}
          <div v-if="!helpNoticeFlag" class="notice-circle"></div>
        </a>
        <a href="https://www.hiworks.com/cs" target="_blank" class="alarm-list-item officehome-gnb-cs">
          {{ $t('고객센터') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionIcon from './Icon/management-service/QuestionIcon.vue';
const mountEl = document.querySelector('#gnb-app');

export default {
  name: 'HelpDesk',
  components: {
    QuestionIcon,
  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
    helpNoticeFlag: {
      type: Boolean,
      required: true,
    },
    isQnaVisible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    serviceGuideUrl() {
      const menuName = mountEl.attributes['data-menu-name'] ? mountEl.attributes['data-menu-name'].value : null;

      if (menuName === 'MAIL_LINK') {
        return 'https://www.hiworks.com/manual/hiworks/103';
      }

      if (menuName === 'EA_LINK') {
        return 'https://www.hiworks.com/manual/hiworks/105';
      }

      if (menuName === 'BILL_LINK') {
        return 'https://www.hiworks.com/manual/hiworks/107';
      }

      if (menuName === 'SMS_LINK') {
        return 'https://www.hiworks.com/manual/hiworks/108';
      }

      return 'https://www.hiworks.com/manual/hiworks/104';
    },
  },
  methods: {
    showQnaList() {
      this.$emit('set-is-qna-visible', !this.isQnaVisible);
      !this.isQnaVisible && this.$nextTick(() => this.$refs.helpDetail.focus());
    },
    helpNoticeFlagReset() {
      this.$emit('set-help-notice-flag-true');
    },
    closeDropdownMenu(e) {
      const isMenuButton = Boolean(e.relatedTarget?.closest('div.help'));
      if (!isMenuButton) this.$emit('set-is-qna-visible', false);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins/icon.scss';
@import '@/assets/scss/base/variables.scss';

.help {
  text-align: left;
  @media (min-width: 900px) {
    position: relative;
  }
}

.help-button {
  @include main-menu-icon('qna');
  border-radius: 4px;
  &:hover {
    background-color: rgba(159, 166, 173, 0.2);
  }
}

.alarm-detail {
  position: fixed;
  width: 100%;
  top: $headerHeight;
  right: 0px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #fff;
  border: solid 1px #909090;
  border-radius: 4px;
  box-shadow: 2px 5px 4px 0 rgba(0, 0, 0, 0.16);
  max-height: calc(100vh - 70px);

  @media (min-width: 900px) {
    position: absolute;
    width: 240px;
    top: 48px;
    right: -10px;
  }

  .notice-circle {
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 3px;
    background-color: #2985db;
    margin-bottom: 8px;
  }

  .alarm-list {
    height: 100%;
    font-size: 14px;
    .alarm-list-item {
      height: 34px;
      padding: 0px 20px;
      color: #333;
      display: block;
      line-height: 34px;
      &:hover {
        background-color: #eff4fc;
        color: currentColor;
      }
    }
  }
}

.help.is-small {
  .help-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    background: none;

    &:hover {
      background-color: rgba(159, 166, 173, 0.2);
    }
  }

  .alarm-detail {
    width: 240px;
    top: $managementHeaderHeight;
    right: 20px;

    .alarm-list {
      .alarm-list-item {
        padding: 8px 16px;
        line-height: 14px;
        font-size: 13px;

        &:hover {
          background-color: #f0f3f6;
        }
      }
    }

    @media (min-width: 900px) {
      position: absolute;
      width: 240px;
      top: 43px;
      right: 0;
    }
  }
}
</style>
